import { useGenericRequestHandler } from '../../handlers'
import type { GenericHandlerValues, USSchoolsDTO } from '../../models'

export type UseUSSchoolsMutationValues = GenericHandlerValues<
  USSchoolsDTO | null,
  'POST'
>

export const useUSSchoolsMutation = (): UseUSSchoolsMutationValues => {
  return useGenericRequestHandler({
    route: 'v1/i/schoolSearch',
    method: 'POST'
  }) as UseUSSchoolsMutationValues
}
